import React from 'react';

import CurrencyPrice from 'src/components/currencyPrice';
import QRCodeBox from 'src/components/QRCodeBox';

import './currency-details.scss';

const CurrencyDetails: React.FC = (): JSX.Element => {
  return (
    <div className="currency-details">
      <CurrencyPrice />
      <QRCodeBox />
    </div>
  );
};

export default CurrencyDetails;
